import { render, staticRenderFns } from "./tinkAboutCore.vue?vue&type=template&id=666e5028"
import script from "./tinkAboutCore.vue?vue&type=script&lang=js"
export * from "./tinkAboutCore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports